import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid2,
} from "@mui/material";
import { Loading } from "./Loading";
import { useEffect, useState } from "react";
import { PayoutDTO } from "../model/entity/PayoutDTO";
import dayjs from "dayjs";
import QRCode from "react-qr-code";
import { putFetcher } from "./Fetchers";
import { convertToIban, notifErr, notifOk } from "./Functions";
import handleAxiosError from "./ErrorHandler";

interface QRCodeDialogProps {
  open: boolean;
  payoutDTO: PayoutDTO;
  handleCancel: any;
}

const QRCodeDialog = (props: QRCodeDialogProps) => {
  const { payoutDTO } = props;
  const [qrValue, setQrValue] = useState<string | null>(null);

  useEffect(() => {
    if (!payoutDTO) return;
    try {
      const iban = convertToIban(payoutDTO.coach.accountNumber);
      const val = `SPD*1.0*ACC:${iban}*AM:${
        payoutDTO.amount
      }*CC:CZK*MSG:Coach payment - ${dayjs(
        payoutDTO.year + "-" + payoutDTO.month
      ).format("MMMM YYYY")}`;
      setQrValue(val);
    } catch (error) {
      notifErr(
        `Nepodařilo se vygenerovat QR kód pro účet ${payoutDTO.coach.accountNumber}.`
      );
    }
  }, [payoutDTO]);

  const handleSubmit = async () => {
    if (!payoutDTO) return;

    const updatedPayoutDTO = { ...payoutDTO, paid: true };

    try {
      await putFetcher(
        `${process.env.REACT_APP_API_URL}/payouts/${payoutDTO.id}`,
        updatedPayoutDTO
      );
      notifOk("Změny byly uloženy.");
      props.handleCancel();
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (!payoutDTO) return <Loading />;

  return (
    <Dialog open={props.open} onClose={() => props.handleCancel()}>
      <DialogContent dividers>
        <Grid2 container>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="h5">
              {payoutDTO.coach.firstName +
                " " +
                payoutDTO.coach.lastName +
                " - " +
                dayjs(
                  `${payoutDTO.year}-${String(payoutDTO.month).padStart(
                    2,
                    "0"
                  )}`
                )
                  .locale("cs")
                  .format("MMMM YYYY")
                  .replace(/^./, (c) => c.toUpperCase())}
            </Typography>
          </Grid2>
          <Grid2
            size={{ xs: 12 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                display: "flex",
                justifyContent: "left",
                mt: "1rem",
                fontSize: "1.2rem",
                fontWeight: "bold",
              }}
            >
              Vyplácená částka: {payoutDTO.amount.toFixed(2).replace(".", ",")}Kč
            </Typography>
            <Grid2
              size={{ xs: 12 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                my: ".5rem",
                width: "fit-content",
              }}
            >
              {qrValue && <QRCode value={qrValue} size={256} />}
            </Grid2>
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 1 }}>
        <Button
          variant="outlined"
          className="cancelBtn"
          onClick={props.handleCancel}
        >
          Zrušit
        </Button>
        <Button
          variant="contained"
          className="successBtnFilled"
          onClick={handleSubmit}
        >
          Vyplacen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeDialog;
